import { render, staticRenderFns } from "./common-access-get-list.vue?vue&type=template&id=b1838fb8&scoped=true&"
import script from "./common-access-get-list.vue?vue&type=script&lang=js&"
export * from "./common-access-get-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1838fb8",
  null
  
)

export default component.exports